export default __webpack_public_path__ + "static/ashish-tiwari-ac4fc43c169099b4e6c0f63aaa0fcbb5.webp";